import { render, staticRenderFns } from "./VxTextArea.vue?vue&type=template&id=292e561b&lang=html&"
import script from "./VxTextArea.vue?vue&type=script&lang=js&"
export * from "./VxTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports